export default "__VITE_ASSET__C$dT9$hh__"